import { postConciergeEvent, postConciergeFlight, postConciergeHotel } from '@/api/concierge'

const concierge = {
  namespaced: true,
  state: () => ({
    status: {},
  }),
  getters: {},
  actions: {
    requestFlight ({
      commit,
      dispatch
    }, flight) {
      return new Promise((resolve, reject) => {
        postConciergeFlight(flight)
          .then((response) => {
            resolve(response)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    requestHotel ({
      commit,
      dispatch
    }, hotel) {
      return new Promise((resolve, reject) => {
        postConciergeHotel(hotel)
          .then((response) => {
            resolve(response)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    requestEvent ({
      commit,
      dispatch
    }, event) {
      return new Promise((resolve, reject) => {
        postConciergeEvent(event)
          .then((response) => {
            resolve(response)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
  mutations: {},
}

export default concierge
